import React, { useState } from 'react';
import { Box } from '../../../base';
import NoEmails from './NoEmails';
import { IServerJobApplicationEmail } from '../../../common';
import EmailItem from './EmailItem';
import EmailDetail from './EmailDetail';

interface Props {
    emails?: Array<IServerJobApplicationEmail>;
    useMockData?: boolean;
}

const EmailTab = (props: Props) => {
    const { emails } = props;
    const [selectedEmail, setSelectedEmail] =
        useState<IServerJobApplicationEmail | null>(null);

    const handleEmailClick = (email: IServerJobApplicationEmail) => {
        setSelectedEmail(email);
    };

    const handleBack = () => {
        setSelectedEmail(null);
    };

    if (selectedEmail) {
        return <EmailDetail emailData={selectedEmail} onBack={handleBack} />;
    }

    return (
        <Box>
            {emails?.length > 0 ? (
                <Box>
                    {emails.map((emailItem) => (
                        <EmailItem
                            key={emailItem.id}
                            emailData={emailItem}
                            onClick={() => handleEmailClick(emailItem)}
                        />
                    ))}
                </Box>
            ) : (
                <NoEmails />
            )}
        </Box>
    );
};

export default EmailTab;
